import React from 'react';
import {Blurhash} from "react-blurhash";

function Image({url, blurhash, aspectRatio, onClick =  () => {}}) {
    return(
        <button type="button" onClick={onClick}>
            <div style={{
                borderRadius: 10,
                position: 'relative',
                aspectRatio,
            }}>
                <div style={{
                    position: 'absolute',
                    borderRadius: 10,
                    overflow: "hidden",
                    flex: 1,
                    inset: 0,
                    zIndex: 1,
                }}>
                    {blurhash !== null ? <Blurhash
                        punch={1}
                        width={'100%'}
                        height={'100%'}
                        className="object-cover"
                        style={{
                            // height: '100%',
                            borderRadius: 10,
                            aspectRatio: aspectRatio,
                        }}
                        hash={blurhash}
                    /> : <></>}
                </div>
                <img alt={""}
                     className="flex object-cover w-full"
                     style={{
                         borderRadius: 10,
                         aspectRatio: aspectRatio,
                         zIndex: 2,
                         position: 'absolute',
                         inset: 0,
                     }}
                     loading="lazy"
                     src={url}/>
            </div>
        </button>
    )
}

export default Image;
